import VModal from '@/vuetify_custom/v-modal_v1'
import VForm from '@/vuetify_custom/v-form'
import FileUploader from '@/views/components/file/uploader';
import EditAttachments from '@/views/components/file/edit_attachments_v1';
import { outsourceContractSaveFinalContractApi } from '../services'
export default {
    data() {
        return {
            show: false,
            saveLoading: false,
            params: {
                id: null,
                bfiles: [],
                final_contract_file_id: null,
            }
        }
    },
    computed: {
        fields_list() {
            return [{
           
                key: 'bfiles',
                required: true,
                rules: [r => {
                    return !![false, true].includes(r) || '必选'
                }],
            }]
        }
    },
    methods: {
        edit(c) {
          //   const final_contract_file = (c.electronic_contract || {}).final_contract_file
            
            this.params.id = c.id
            this.params.bfiles = []
            this.params.final_contract_file_id = null
            this.$refs.form && this.$refs.form.resetValidation()
            this.$nextTick(() => {
                this.show = true
            })
        },
        submit() {
            if (this.params.bfiles.length === 1) {
                this.saveLoading = true
                const {bfiles, ...other} = this.params
                other.final_contract_file_id = bfiles[0].id
                outsourceContractSaveFinalContractApi(other).then(() => {
                    this.$Message.success('数据修改成功！')
                    this.show = false
                    this.$emit('success')
                }).finally(() => {
                    this.saveLoading = false
                })
            } else {
                this.$vModal.error({
                    title: '提示',
                    content: '请上传文件！'
                })
            }
        }
    },
   render() {
    const _this = this
    return <VModal 
    dynamicHeight
    heightRate={0.2}
    v-model={this.show}
    title='上传最终版文件'
    loading={this.saveLoading}
    width={500}
    ref="modal"
    // cancelText={_this.params.pigeonhole_flag === 1 ? '' : '取消'}
    // okText={_this.params.pigeonhole_flag === 1 ? '关闭' : '确定'}
    on={{
    ok: () => {
        _this.submit()
    }
    }}
>
    <div>
        <VForm 
            ref="form"
            v-model={_this.params}
            fields={_this.fields_list}
            disabled={_this.params.fiel}
            scopedSlots={{
                bfiles:({field} = {}) => {
                    return <div style="display:flex">
                    <p style="width:40px">
                        附件
                    </p>
                    <div style="flex:1">
                        <EditAttachments
                            files={_this.params.bfiles}
                            modelType="OutsourceContract"
                            modelId={_this.params.id}
                            />
                            <FileUploader 
                                disabled={this.params.bfiles.length === 1}
                                validateFile={(file) => {
                                    const a = /\.[0-9a-zA-Z]+$/.test(file.name)
                                    if (!a) {
                                      this.$vModal.warning({
                                          title:'提示',
                                          content:'文件格式错误，无法解析。建议上传如下类型：.xlsx、.pdf等带有后缀的'
                                      })
                                    }
                                    return a
                                }}
                                on={{
                                    uploaded: (bfile) => {
                                        _this.params.bfiles.push(bfile)
                                    }
                                }}/>
                            <span class="color-error">为保证兼容性及文档可编辑性，请上传office系列的文档(Word, Excel, PPT)</span>
                    </div>
                </div>
                },
            }}
            >
        </VForm>
    </div>
</VModal>
   } 
}